import SvgIconfont from '@/components/commonComponents/SvgIconfont.vue';
import PageBackHeader from '@/components/commonComponents/pageBackHeader.vue';
import SinglePicOrPdfCard from '@/components/commonComponents/SinglePicOrPdfCard.vue';

export default {
  components: {
    SvgIconfont,
    PageBackHeader,
    SinglePicOrPdfCard
  },
};
